import React, { useEffect, useState } from "react";
import api from "../utils/api";
import { URLS, ImgURL } from "../utils/urls";

const AdminMediaGallery = ({ onSelect, accept = "*" }) => {
  const [media, setMedia] = useState([]);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    loadMedia();
  }, []);

  const loadMedia = async () => {
    const res = await api.get(URLS.GET_MEDIA_LIST);
    setMedia(res.data);
  };

  const uploadFiles = async (files) => {
    setUploading(true);
    const formData = new FormData();
    for (let f of files) formData.append("files", f);

    await api.post(URLS.UPLOAD_MEDIA_LIST, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    setUploading(false);
    loadMedia();
  };

  const onDrop = (e) => {
    e.preventDefault();
    uploadFiles(e.dataTransfer.files);
  };

  const deleteMedia = async (id) => {
    if (!window.confirm("Delete this file?")) return;
    await api.delete(URLS.DELETE_SINGLE_MEDIA(id));
    loadMedia();
  };

  return (
    <div className="p-4 rounded bg-white" style={{ minHeight: "400px", maxHeight: "80vh", overflowY: "auto" }}>
      <h2 className="text-xl font-semibold mb-3">Media Library</h2>

      {/* Upload */}
      <div
        className="border-dashed border-2 p-6 text-center mb-4"
        onDrop={onDrop}
        onDragOver={(e) => e.preventDefault()}
      >
        Drag & Drop files here or
        <input
          type="file"
          multiple
          accept={accept}
          onChange={(e) => uploadFiles(e.target.files)}
          className="block mt-2"
        />
      </div>

      {/* Gallery */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {media.map((m) => (
          <div key={m.id} className="border rounded p-2 relative group">
            {m.mime_type.startsWith("image") && (
              <img src={ImgURL(m.url)} alt="" className="w-full h-32 object-cover" />
            )}

            {m.mime_type.startsWith("audio") && (
              <audio controls src={ImgURL(m.url)} className="w-full" />
            )}

            {m.mime_type.startsWith("video") && (
              <video controls src={ImgURL(m.url)} className="w-full h-32" />
            )}

            <div className="flex justify-between mt-2">
              <button
                className="text-blue-600 text-sm"
                onClick={() => onSelect(m)}
              >
                Select
              </button>

              <button
                className="text-red-500 text-sm"
                onClick={() => deleteMedia(m.id)}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {uploading && <p className="mt-2 text-sm">Uploading...</p>}
    </div>
  );
};

export default AdminMediaGallery;
